module.exports = __webpack_public_path__ + "img/api.db68c910.svg";